import API from "../api"

export const getSubCategories = async (id) => {
  try {
    return await API.get(`/get-sub-categories/${id}`)
  } catch (error) {
    console.log(error)
  }
}
